import { HttpApiRequestOptions } from './types';

export function getQueryParam(param: string): string | void {
  const locationHash = window.location.hash.substring(1).split('?')[1] || '';
  const query = window.location.search.substring(1) || locationHash;
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === param) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export function removeQueryParam(paramName: string): void {
  let uri = window.location.toString();
  uri = uri
    .replace(new RegExp('[?&]' + paramName + '=[^&#]*(#.*)?$'), '$1')
    .replace(new RegExp('([?&])' + paramName + '=[^&]*&'), '$1');
  window.history.replaceState({}, document.title, uri);
}

export abstract class HttpClientUrlBuilder<T = HttpApiRequestOptions> {
  public abstract buildUrl(path: string, requestOptions?: T): string;
}
